<template>
    <div id="content">
        <div class="container-fluid page-title">
            <div class="container">
                <h1>
                    Acesso Parceiro
                </h1>
                <p class="info">
                    Acesso exclusivo a Parceiros credenciados. Ainda não é parceiro?
                    <router-link to="/seja-um-parceiro" class="text-light">Clique aqui.</router-link>
                </p>
            </div>
        </div>
        <div class="container mt-4">
            <div class="card text-center col-lg-4 col-md-10 col-sm-12 p-0" style="margin: 0 auto">
                <div class="card-header">
                    <b>Acesso Parceiro</b>
                </div>
                <div class="card-body">
                    <form :action="url_catalogo+'/app/auth/login_check'" method="post" class="pb-4">
                        <div class="form-group">
                            <label for="username">Usuario</label>
                            <input type="text" id="username" class="form-control" name="_username">
                        </div>
                        <div class="form-group">
                            <label for="password">Senha</label>
                            <input type="password" id="password" class="form-control" name="_password">
                        </div>
                        <button type="submit" class="btn btn-danger">Entrar</button>
                    </form>
                    <router-link class="btn btn-dark" to="/seja-um-parceiro">
                        Seja um Parceiro!
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data: () => ({
            url_catalogo: null,
            erros: null,
        }),
        methods: {
            getConfigCatalogo: function () {
                axios.get('/api/config?name=url_catalogo')
                    .then(response => {
                        this.url_catalogo = response.data.config;
                    })
                    .catch(e => {
                        this.errors.push(e)
                    })
            }
        },
        created() {
            this.getConfigCatalogo();
        }
    }
</script>



// WEBPACK FOOTER //
// Acesso.vue?36822d30